export default {
  setGlobalErrorModal(state, boo) {
    state.errorModal = boo;
  },
  pushError(state, boo) {
    state.errorModal(boo);
  },
};
